import { getState, modifyState, incrementState } from '~src/state';
import { updateUndoRedoControls } from '~core';
import { editorConfig } from '~config';

export const addEditorHistoryEntry = () => {
  if (getState('pauseCanvasHistory', false) === true) {
    console.debug('Skipping Canvas History due to pause request');
    return;
  }

  const undoInProgress = getState('undoInProgress');
  const redoInProgress = getState('redoInProgress');
  const currentPageIndex = getState('currentPageIndex');
  const isChangingPage = getState('isChangingPage');
  const history = getState(`history[${currentPageIndex}]`, []);

  if (
    undoInProgress === false &&
    redoInProgress === false &&
    isChangingPage === false
  ) {
    const currentEditorState = JSON.stringify(window.canvas);
    history.push(currentEditorState);

    // Ogni voce è l'intero canvas serializzato e se ne aggiunge una a ogni
    // tasto: senza limite la memoria cresce per tutta la sessione.
    const overflow = history.length - editorConfig.historyMaxEntriesPerPage;
    if (overflow > 0) {
      history.splice(0, overflow);
    }

    modifyState(`history[${currentPageIndex}]`, history);

    incrementState(`currentHistoryIndex[${currentPageIndex}]`);
    if (overflow > 0) {
      const currentHistoryIndex = getState(
        `currentHistoryIndex[${currentPageIndex}]`
      );
      modifyState(
        `currentHistoryIndex[${currentPageIndex}]`,
        Math.max(currentHistoryIndex - overflow, 0)
      );
    }
    incrementState('totalChangesSinceLastSave');
  }

  updateUndoRedoControls();
};
